import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';
import TradeInVehicleModel from 'commons-vehicle/Vehicle/models/TradeInVehicleModel.js';
import MultiMediaModel from 'commons-vehicle/Vehicle/models/MultiMediaModel.js';
import PaymentOptionsModel from 'commons-vehicle/Vehicle/models/PaymentOptionsModel.js';

import VehicleActions from 'commons-vehicle/Vehicle/actions/vehicleActions.js';
import VehicleActionTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';
import TradeInValue from 'commons-vehicle/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.jsx';
import TradeInVehicleActions from 'commons-vehicle/Vehicle/actions/tradeInVehicleActions.js';
import TradeInVehicleActionTypes from 'commons-vehicle/Vehicle/actions/tradeInVehicleActionTypes.js';

import VehicleReducer from 'commons-vehicle/Vehicle/reducers/vehicleReducer.js';
import TradeInVehicleReducer from 'commons-vehicle/Vehicle/reducers/tradeInVehicleReducer.js';

import VehicleService from 'commons-vehicle/Vehicle/services/VehicleService/VehicleService.js';
import VehicleAPIService from 'commons-vehicle/Vehicle/services/VehicleAPIService/VehicleAPIService.js';
import TradeInVehicleService from 'commons-vehicle/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js';
import TradeInVehicleAPIService from 'commons-vehicle/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js';

import CertificationIconService from 'commons-vehicle/Vehicle/services/CertificationIconService/CertificationIconService.js';

import BADGE_STATUS from 'commons-vehicle/Vehicle/constants/badgeStatus.js';
import TRADEIN_STATUSES from 'commons-vehicle/Vehicle/constants/tradeInVehicleStatuses.js';
import URL from 'commons-vehicle/Vehicle/constants/url.js';

import Payment from 'commons-vehicle/Vehicle/components/Payment/Financing/Financing.jsx';
import CashPayment from 'commons-vehicle/Vehicle/components/Payment/CashPayment/CashPayment.jsx';
import PaymentDetail from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx';
import Overview from 'commons-vehicle/Vehicle/components/Overview/Overview.jsx';
import VehicleSummary from 'commons-vehicle/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx';
import Price from 'commons-vehicle/Vehicle/components/Payment/Price/Price.jsx';
import AppointmentCTA from 'commons-vehicle/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx';
import BuyOnlineCTA from 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx';
import BuyOnlineCTAV25 from 'commons-vehicle/Vehicle/components/CallToAction/BuyOnlineV25/BuyOnlineCTAV25.jsx';
import PriceQuoteCTA from 'commons-vehicle/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.jsx';
import TradeInCTA from 'commons-vehicle/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx';
import CallToActionBar from 'commons-vehicle/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.jsx';
import PaymentOptionFilters from 'commons-vehicle/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.jsx';
import VehicleBannerWithCarrousel from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.jsx';
import VehicleRebate from 'commons-vehicle/Vehicle/components/VehicleRebate/VehicleRebate.jsx';
import LightboxCarrousel from 'commons-vehicle/Vehicle/components/LightboxCarrousel/LightboxCarrousel.jsx';
import VehicleDisclaimersContent from 'commons-vehicle/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.jsx';
import VehicleTitleSpecs from 'commons-vehicle/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.jsx';

import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';

import en from 'commons-vehicle/Vehicle/i18n/en.json';
import fr from 'commons-vehicle/Vehicle/i18n/fr.json';

const Translation = { en, fr };

export {
    VehicleActions,
    VehicleActionTypes,
    TradeInVehicleActions,
    TradeInVehicleActionTypes,
    CallToActionBar,
    Payment,
    CashPayment,
    Price,
    PaymentDetail,
    Overview,
    VehicleSummary,
    Translation,
    VehicleModel,
    VehicleReducer,
    VehicleService,
    VehicleAPIService,
    MultiMediaModel,
    TradeInValue,
    TradeInVehicleModel,
    TradeInVehicleReducer,
    TradeInVehicleService,
    TradeInVehicleAPIService,
    CertificationIconService,
    BADGE_STATUS,
    TRADEIN_STATUSES,
    URL,
    TradeInCTA,
    AppointmentCTA,
    BuyOnlineCTA,
    BuyOnlineCTAV25, // SHOWROOM V2.5
    PriceQuoteCTA,
    PaymentOptionsModel,
    PaymentOptionFilters,
    VehicleBannerWithCarrousel,
    VehicleRebate,
    LightboxCarrousel,
    VehicleDisclaimersContent,
    VehicleTitleSpecs,
    TileTag,
};

export default {
    VehicleActions,
    VehicleActionTypes,
    TradeInVehicleActions,
    TradeInVehicleActionTypes,
    BADGE_STATUS,
    URL,

    CallToActionBar,
    Payment,
    CashPayment,
    Price,
    PaymentDetail,
    Overview,
    VehicleSummary,
    Translation,
    VehicleModel,
    VehicleReducer,
    VehicleService,
    VehicleAPIService,
    MultiMediaModel,
    CertificationIconService,

    TradeInValue,
    TradeInVehicleModel,
    TradeInVehicleReducer,
    TradeInVehicleService,
    TradeInVehicleAPIService,
    TRADEIN_STATUSES,

    TradeInCTA,
    AppointmentCTA,
    BuyOnlineCTA,
    BuyOnlineCTAV25, // SHOWROOM V2.5
    PriceQuoteCTA,
    PaymentOptionsModel,
    PaymentOptionFilters,
    VehicleBannerWithCarrousel,
    VehicleRebate,
    LightboxCarrousel,
    VehicleDisclaimersContent,
    VehicleTitleSpecs,
    TileTag,
};



// WEBPACK FOOTER //
// ./src/Vehicle/index.js